import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {DevicesState, Device}				from './interface';
import actions 								from './devicesAction';

const initialState: DevicesState = {
	isLoad:         false,
	isLoadAssign:   false,
	isLoadPut:      false,
	data:           [],

	mdm: {
		jamf:   [],
		vmWare: []
	}
};

export const getDevicesApi = createAsyncThunk('devices/getDevicesApi', actions.getDevicesApi);
export const assignDevicesApi = createAsyncThunk('devices/assignDevicesApi', actions.assignDevices);
export const putDevicesApi = createAsyncThunk('devices/putDevicesApi', actions.putDeviceApi);
export const postDevicesApi = createAsyncThunk('devices/postDevicesApi', actions.postDevice);
export const deleteDevicesApi = createAsyncThunk('devices/deleteDevicesApi', actions.deleteDevice);

export const getMdmDevicesApi = createAsyncThunk('devices/getMdmDevicesApi', actions.getMdmDevicesApi);

export const Reducer = createSlice({
	initialState,
	name:     'devices',
	reducers: {},

	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getDevicesApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getDevicesApi.fulfilled, (state, action) => {
			state.isLoad = false;
			state.data = action.payload;
		})
		.addCase(getMdmDevicesApi.fulfilled, (state, action) => {
			state.mdm[action.payload.name] = action.payload.value;
		})
		// --- POST
		.addCase(postDevicesApi.fulfilled, (state, action) => {
			if (action.payload._id)
				state.data.push(action.payload);
		})
		// --- PUT
		.addCase(putDevicesApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putDevicesApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: Device[] = state.data.map((device) => {
				if (!device || action.payload._id !== device._id)
					return device;
				return {
					...device,
					...action.payload,
					shopData: device.shopData,
					user:     action.payload.user
				};
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		})
		// --- Assign
		.addCase(assignDevicesApi.pending, (state) => {
			state.isLoadAssign = true;
		})
		.addCase(assignDevicesApi.fulfilled, (state, action) => {
			const copy: Device[] = state.data.map((device) => {
				const index = action.payload.findIndex(find => find?._id === device?._id);

				if (index !== -1)
					return {...device, user: action.payload[index].user};
				return device;
			});

			return ({
				...state,
				isLoadAssign: false,
				data:         copy
			});
		})
		// --- DELETE
		.addCase(deleteDevicesApi.fulfilled, (state, action) => {
			const index = state.data.findIndex(find => find?._id === action?.payload);
			const copy = [...state.data];

			if (index !== -1)
				copy.splice(index, 1);
			return ({...state, data: copy});
		});
	}
});

export default Reducer.reducer;
